import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SCRIPT_URL = `${API}/ookla-setup.sh`;

const TOKEN_KEY = "twintc_token";
const USER_KEY = "twintc_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getStoredUser = () => localStorage.getItem(USER_KEY);
export const saveAuth = (token, username) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, username);
};
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const onUnauthorized = { handler: null };

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    // Expected 401s (wrong password on login / change-credentials) must NOT log the user out
    const isAuthEndpoint = url.includes("/auth/login") || url.includes("/auth/change-credentials");
    if (err?.response?.status === 401 && !isAuthEndpoint && onUnauthorized.handler) {
      onUnauthorized.handler();
    }
    return Promise.reject(err);
  }
);
